import { Spacer, Switch, Waveform } from '@sparemin/blockhead';
import React from 'react';

import LinkButton from 'components/LinkButton';

import { block } from '../../../utils';

interface TranscriptAddCaptionsCardProps {
  onClickCaptionUpload: () => void;
}

const VALUE_CHANGE_INTERVAL_MS = 2000;

const WaveformIcon = <Waveform fontSize={28} />;

const TranscriptAddCaptionsCard: React.FunctionComponent<TranscriptAddCaptionsCardProps> = props => {
  const { onClickCaptionUpload } = props;

  const [switchValue, setSwitchValue] = React.useState(false);

  React.useEffect(() => {
    const intervalRef = setInterval(() => {
      setSwitchValue(prev => !prev);
    }, VALUE_CHANGE_INTERVAL_MS);

    return () => {
      clearInterval(intervalRef);
    };
  }, []);

  return (
    <Spacer
      className={block('captions-message-content')}
      orientation="vertical"
      space={2.5}
    >
      <Spacer
        className={block('captions-message-line')}
        orientation="vertical"
        space={1}
      >
        <div>1. Select your audio or video object below</div>
        <div className={block('captions-waveform-sample')}>
          {WaveformIcon}
          {WaveformIcon}
          {WaveformIcon}
          {WaveformIcon}
          {WaveformIcon}
          {WaveformIcon}
          {WaveformIcon}
        </div>
      </Spacer>
      <Spacer
        className={block('captions-message-line')}
        orientation="vertical"
        space={1}
      >
        <div>2. Once opened, turn on captions!</div>
        <Switch
          className={block('captions-animated-switch')}
          isSelected={switchValue}
          value={switchValue ? 'on' : 'off'}
        />
      </Spacer>
      <Spacer
        className={block('captions-message-line')}
        orientation="vertical"
        space={1}
      >
        <div className={block('own-captions-title')}>
          Have your own captions already?
        </div>
        <LinkButton
          className={block('own-captions-btn')}
          onClick={onClickCaptionUpload}
        >
          Upload pre-existing captions
        </LinkButton>
      </Spacer>
    </Spacer>
  );
};

export default TranscriptAddCaptionsCard;
